import { put } from 'redux-saga/effects';
import axios from 'src/api/Api';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';
import {
    GET_PAGEVISIBILITYRULE_SUCCESS,
    GET_PAGEVISIBILITYRULE_FAILURE,
} from '../actions';
import { convertObjectToQueryParams } from 'src/utils/util';

export default function* getPageVisibilityRule(action) {
    const params = convertObjectToQueryParams({ ...action.payload });
    const url = `/occ/v2/${localStorage.getItem('baseSiteId')}/pagevisibilityrule?${params}`;
    try {
        const result = yield axios.get(url).then((response) => response.data);

        yield put({ type: GET_PAGEVISIBILITYRULE_SUCCESS, data: result });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: url,
            requestPayload: action.payload,
        });
        yield put({
            type: GET_PAGEVISIBILITYRULE_FAILURE,
            templateError: errorHandler('503'),
        });
    }
}
